exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: block;\n    position: relative;\n    padding: 0px 16px;\n}\n\n:host(.item-selected) {\n    font-weight: bold;\n}\n\n:host ::ng-deep pbutton {\n    display: inline-block;\n    padding: 0;\n    font-size: 1em;\n    text-transform: none;\n    border-top-width: 1px;\n    border-right-width: 1px;\n    box-shadow: none;\n    margin: 0;\n}\n\n:host ::ng-deep pbutton:active {\n    box-shadow: none;\n}\n\n:host ::ng-deep .icon {\n    display: inline-block;\n    box-sizing: border-box;\n    height: 18px;\n    width: 18px;\n    border-radius: 2px;\n    border: 2px solid rgb(63, 81, 181);\n    margin-right: 8px;\n    background-color: rgb(63, 81, 181);\n}\n\n:host ::ng-deep .icon > svg {\n    margin: 1px auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-item/paper-item.component.css
// module id = ./src/app/components/polymer/paper-item/paper-item.component.css
// module chunks = main